import { Button, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import AddIcon from "../../../../assets/icons/AddIcon";
import EditIcon from "../../../../assets/icons/EditIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import ManageShift from "../../../../components/Settings/Shift/ManageShift";
import ShiftDetailsModal from "../../../../components/Settings/Shift/ShiftDetailsModal";
import CustomTable from "../../../../components/ui/CustomTable";
import { useGetBusinessShiftsQuery } from "../../../../features/businessShift/businessShiftApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatOnlyTime } from "../../../../lib/time";
import { addKeyInArray, skipData } from "../../../../utils/utils";
import { officeSettingsTabList } from "./officeSettingsTabList";

// enum BusinessShiftStatus {
//   "Inactive",
//   "Active",
// }

export default function Shift() {
  const { open, handleClose, handleOpen } = useModal();
  const { page, limit, handlePagination, handleLimit } = useTable();
  // const [
  //   updateBusinessShiftStatus,
  //   {
  //     isSuccess: isStatusUpdateSuccess,
  //     isError: isStatusUpdateError,
  //     error: statusUpdateError,
  //   },
  // ] = useUpdateBusinessShiftStatusMutation();
  const { isLoading, isError, error, data } = useGetBusinessShiftsQuery({
    params: {
      limit,
      skip: skipData(page, limit),
    },
  });

  useError(isError, error, "Get business data fail");
  // useError(
  //   isStatusUpdateError,
  //   statusUpdateError,
  //   "Business status update fail"
  // );

  const columns: ColumnsType<any> = [
    {
      title: "Shift",
      render: (val) => (
        <div className="flex items-center">
          <span
            className="w-6 h-6 rounded-md mr-2"
            style={{ backgroundColor: val?.color_code || "#ddd" }}
          />
          {val?.title}
        </div>
      ),
    },
    {
      title: "Time",
      render: (val) =>
        `${formatOnlyTime(val?.start_time)} - ${formatOnlyTime(val?.end_time)}`,
    },
    {
      title: "Max Office Hours",
      dataIndex: "max_office_hours",
      render: (val) => (val || 0) + " Hours",
    },
    // {
    //   title: "Shift",
    //   render: (val) => (
    //     <Space size={4}>
    //       <Switch
    //         checked={val?.is_published === 1}
    //         onChange={(checked) =>
    //           updateBusinessShiftStatus({
    //             id: val?.id,
    //             body: {
    //               is_published: checked ? 1 : 0,
    //             },
    //           })
    //         }
    //       />
    //       <span className="text-header text-sm font-medium">
    //         {BusinessShiftStatus[val?.is_published ?? 0]}
    //       </span>
    //     </Space>
    //   ),
    // },
    {
      title: "Action",
      width: 200,
      render: (val) => (
        <Space size={8}>
          <Button
            className="action-button"
            size="small"
            icon={<EditIcon />}
            onClick={() =>
              handleOpen({
                type: "UPDATE",
                data: val?.id,
              })
            }
          />

          <Button
            className="action-button"
            icon={<ViewIcon />}
            size="small"
            onClick={() => {
              handleOpen({
                type: "VIEW",
                data: val?.id,
              });
            }}
          />
        </Space>
      ),
    },
  ];

  // success toast message
  // useEffect(() => {
  //   if (isStatusUpdateSuccess) {
  //     toast("success", "Business status updated successfully");
  //   }
  // }, [isStatusUpdateSuccess]);

  return (
    <SidebarLayout title="Office Settings" tabList={officeSettingsTabList}>
      {(open.type === "ADD" || open.type === "UPDATE") && (
        <ManageShift
          open={open.open}
          data={open.data}
          type={open?.type}
          handleClose={handleClose}
        />
      )}

      {open.type === "VIEW" && (
        <ShiftDetailsModal
          open={open.open}
          data={open.data}
          handleClose={handleClose}
        />
      )}

      <div className="bg-white p-4 rounded-md">
        <div className="flex justify-between items-center mb-4">
          <div className="text-[22px] text-[#2D3643]">Shift Settings</div>
          <div>
            <Button
              type="primary"
              className="flex gap-2 items-center"
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              <AddIcon />
              <span>Add New Shift</span>
            </Button>
          </div>
        </div>
        <CustomTable
          loading={isLoading}
          limit={limit}
          page={page}
          columns={columns}
          total={data?.data?.totalLength}
          dataSource={addKeyInArray(data?.data?.shifts)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={null}
          // hideRowSelect
          // hidePagination
        />
      </div>
    </SidebarLayout>
  );
}
